class Logger {
    static debug(message, trace) {
        Logger.log(message, 100, trace, "");
    }

    static info(message, trace) {
        Logger.log(message, 200, trace || "");
    }

    static warning(message, trace) {
        Logger.log(message, 300, trace || "");
    }

    static error(message, trace) {
        Logger.log(message, 400, trace || "");
    }

    static log(message, level, trace) {
        if (typeof this.logs === "undefined") {
            this.logs = [];
        }
        if (this.logs[message] === true) {
            return;
        }
        this.logs[message] = true;
        if (typeof message === "string") {
            if (message.indexOf("userAgent") >= 0) {
                return;
            }
            if (message.indexOf("Fullscreen") >= 0) {
                return;
            }
            if (message.indexOf("play method") >= 0) {
                return;
            }
            if (message.indexOf("WebSocket") >= 0) {
                return;
            }
            if (message.indexOf("Blocked a frame") >= 0) {
                return;
            }
            if (message.indexOf("jQuery is not defined") >= 0) {
                return;
            }
            if (message.indexOf("$ is not defined") >= 0) {
                return;
            }
            if (message.length === 0) {
                return;
            }
            if (message.indexOf("connection-timeout") >= 0) {
                return;
            }
        }

        if (typeof app === "object") {
            const version = parseInt((app && app.config && app.config.version) ? app.config.version : 0);
            const xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4 && xhr.status === 200) {
                    const serverVersion = parseInt(xhr.response);
                    if (typeof app.config.user === "object" && version && serverVersion && serverVersion !== version) {
                        app.notifications.showForceReload(app.config.translate.force_reload_title, app.config.translate.force_reload_message, (Date.now() / 1000) + 60);
                    }
                }
            };
            xhr.open("post", "/services/client/log", true);
            xhr.setRequestHeader("X-Requested-With", 'XMLHttpRequest');
            xhr.send(JSON.stringify({
                msg: message,
                level: level,
                url: window.location.href,
                version: version,
                trace: trace,
                storageStatus: version ? app.storage.status() : {}
            }));
        }
    }
}
